// src/components/contact/ContactDetails.jsx
import React from 'react';
import styles from './ContactDetails.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';

const ContactDetails = ({ offices, phone, email }) => {
  return (
    <div className={styles.contactDetails}>
      {/* Loop through each office to display its address */}
      {offices.map((office, officeIndex) => (
        <div key={officeIndex} className={styles.officeBlock}>
          <h3 className={styles.officeTitle} style={{ animationDelay: `${officeIndex * 0.4}s` }}>
            {office.type}
          </h3>
          <div className={styles.detailsList}>
            <div className={styles.detailItem} style={{ animationDelay: `${officeIndex * 0.4 + 0.1}s` }}>
              <FontAwesomeIcon icon={faMapMarkerAlt} className={styles.icon} />
              <p><strong>Address:</strong> {office.address}, {office.city} - {office.pincode}</p>
            </div>
          </div>
        </div>
      ))}
      
      {/* Display the common phone and email once, with a separate animation delay */}
      <div className={styles.detailsList} style={{ marginTop: '30px' }}>
        <div className={styles.detailItem} style={{ animationDelay: `${offices.length * 0.4 + 0.1}s` }}>
          <FontAwesomeIcon icon={faPhone} className={styles.icon} />
          <p><strong>Phone:</strong> {phone}</p>
        </div>
        <div className={styles.detailItem} style={{ animationDelay: `${offices.length * 0.4 + 0.2}s` }}>
          <FontAwesomeIcon icon={faEnvelope} className={styles.icon} />
          <p><strong>Email:</strong> {email}</p>
        </div>
      </div>
    </div>
  );
};

export default ContactDetails;